import { createSlice } from "@reduxjs/toolkit";
import { DEMO_STEP_ORDER } from "@constants/demoFlow";

const initialState = {
  isActive: false,
  currentStep: null, // string step name from DEMO_STEP_ORDER
  demoAgendaId: null,
  meetingInstanceId: null,
  winningOption: null,
  winningVoteCount: 0,
  totalVotes: 0,
  secondWinningOption: null,
  secondWinningVoteCount: 0,
  secondTotalVotes: 0,
  demoStartTime: null, // for analytics timing
};

export const demoSlice = createSlice({
  name: "demo",
  initialState,
  reducers: {
    startDemo: (state, action) => {
      state.isActive = true;
      state.currentStep = DEMO_STEP_ORDER[0]; // "WELCOME"
      state.demoAgendaId = action.payload?.agendaId || null;
      state.demoStartTime = Date.now();
    },
    setDemoStep: (state, action) => {
      state.currentStep = action.payload;
    },
    advanceDemoStep: (state) => {
      const currentIndex = DEMO_STEP_ORDER.indexOf(state.currentStep);
      if (currentIndex >= 0 && currentIndex < DEMO_STEP_ORDER.length - 1) {
        state.currentStep = DEMO_STEP_ORDER[currentIndex + 1];
      }
    },
    setMeetingInstanceId: (state, action) => {
      state.meetingInstanceId = action.payload;
    },
    setWinningOption: (state, action) => {
      state.winningOption = action.payload.option;
      state.winningVoteCount = action.payload.voteCount;
      state.totalVotes = action.payload.totalVotes;
    },
    setSecondWinningOption: (state, action) => {
      state.secondWinningOption = action.payload.option;
      state.secondWinningVoteCount = action.payload.voteCount;
      state.secondTotalVotes = action.payload.totalVotes;
    },
    endDemo: (state) => {
      state.isActive = false;
      state.currentStep = null;
      state.demoAgendaId = null;
      state.meetingInstanceId = null;
      state.winningOption = null;
      state.winningVoteCount = 0;
      state.totalVotes = 0;
      state.secondWinningOption = null;
      state.secondWinningVoteCount = 0;
      state.secondTotalVotes = 0;
      state.demoStartTime = null;
    },
  },
});

export const {
  startDemo,
  setDemoStep,
  advanceDemoStep,
  setMeetingInstanceId,
  setWinningOption,
  setSecondWinningOption,
  endDemo,
} = demoSlice.actions;

export default demoSlice.reducer;
